import React from 'react'

const contacto = [
    {
        logo: '',
        phone: '2209-2838',
        mail: 'dts@ufg.edu.sv',
        location: 'Dirección de Tecnología y Sistemas, 4to. Nivel del Edificio de Biblioteca y Laboratorios Especializados (EBLE).'
    },
    {
        logo: '',
        phone: '2249-2763 | 2249-2764 | 2249-2752',
        mail: 'cdsoft@ufg.edu.sv',
        location: 'Edificio de Postgrados y Educación Continua, Primer Nivel, Oficinas CDSOFT.'
    },
]

function ContactInfo() {
    return (
        <section className="pt-10">
            <div className="flex flex-col text-center w-full mb-4">
                <h1 className="text-2xl font-medium title-font mb-4 blue-654C tracking-widest">INFORMACIÓN DE CONTACTO</h1>
            </div>
            <ul className="rounded-md shadow-md bg-white mt-3 p-3">
                <li className="text-xs uppercase font-medium blue-3005C border-b border-gray border-solid py-2 px-5 mb-2">
                    CONTACTOS Y UBICACIÓN
                </li>
                {contacto.map(({ phone, mail, location, logo }) => (
                    <li className="grid grid-cols-5 gap-4 cursor-pointer px-4 py-2 rounded-lg hover:bg-gray-50" key={mail}>

                        <div className="flex justify-center items-center">
                            <span className="flex absolute justify-center items-center w-10 h-10 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 20v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                                    <circle cx="10" cy="7" r="4"></circle>
                                </svg>
                            </span>
                        </div>
                        <div className="col-start-2 col-end-11 pl-8 border-l-2 border-solid border-gray">
                            <div className="text-sm font-medium text-gray-900">{phone}</div>
                            <div className="text-sm text-blue-500">{mail}</div>
                            <div className="text-sm text-justify text-gray-900">{location}</div>
                        </div>
                    </li>
                ))}
                <li className="text-xs uppercase font-medium blue-3005C border-b border-gray border-solid py-2 px-5 mb-2">
                    HORARIOS DE ATENCIÓN
                </li>
                <li className="grid grid-cols-5 gap-4 justify-center items-center cursor-pointer px-4 py-2 rounded-lg hover:bg-gray-50">
                    <div className="flex justify-center items-center">
                        <span className="flex absolute justify-center items-center w-10 h-10 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                            <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                        </span>
                    </div>
                    <div className="col-start-2 col-end-11 pl-8 border-l-2 border-solid border-gray">
                        <h3 className="text-gray-900 font-medium text-md">Lunes a Viernes</h3>
                        <p className="text-gray-600 mt-1 font-regular text-sm">8:00 am - 12:00 pm <br />1:00 pm - 5:00 pm</p>
                    </div>
                </li>
                <li className="grid grid-cols-5 gap-4 justify-center items-center cursor-pointer px-4 py-2 rounded-lg hover:bg-gray-50">
                    <div className="flex justify-center items-center">
                        <span className="flex absolute justify-center items-center w-10 h-10 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                            <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                        </span>
                    </div>
                    <div className="col-start-2 col-end-11 pl-8 border-l-2 border-solid border-gray">
                        <h3 className="text-gray-900 font-medium text-md">Sábado</h3>
                        <p className="text-gray-600 mt-1 font-regular text-sm">8:00 am - 12:00 pm</p>
                    </div>
                </li>
            </ul>
        </section>
    )
}

export default ContactInfo